/**
 * Represents the color gradient for the losers and detractors in the performance by index module
 */
export const NEGATIVE_INDICES_COLOR = [
    'bg-negative-1',
    'bg-negative-2',
    'bg-negative-3',
    'bg-negative-4',
    'bg-negative-5',
    'bg-negative-6',
    'bg-negative-7',
    'bg-negative-8',
];
/**
 * Represents the length of NEGATIVE_INDICES_COLOR and POSITIVE_INDICES_COLOR which is the number of gradients
 */
export const NUMBER_OF_COLOR_GRADIENTS = 8;
/**
 * Represents the color gradient for the gainers and contributors in the performance by index module
 */
export const POSITIVE_INDICES_COLOR = [
    'bg-positive-1',
    'bg-positive-2',
    'bg-positive-3',
    'bg-positive-4',
    'bg-positive-5',
    'bg-positive-6',
    'bg-positive-7',
    'bg-positive-8',
];
export const DEFAULT_CALC_COLUMNS = [
    {
        metricDisplayValue: '1 Day Returns (Daily)',
        metricInternalName: 'roc_1',
        columnType: 'metric',
    },
    {
        metricDisplayValue: '1 Month Total Returns (Daily)',
        metricInternalName: 'one_month_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: 'Year to Date Total Returns (Daily)',
        metricInternalName: 'ytd_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: '1 Year Total Returns (Daily)',
        metricInternalName: 'one_year_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: '3 Year Total Returns (Daily)',
        metricInternalName: 'three_year_total_return',
        columnType: 'metric',
    },
];
